export default __webpack_public_path__ + "static/media/eSpot33x.2e0b4133.png";